import styled from 'styled-components';

const Wrapper = styled.div`
  .component_chart_label {
    transform: translateY(-16px);
  }
`;

export default Wrapper;
